import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    tableRoot: {
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTableCell-head": {
        background: "#DAF7FB"
      },
      "& .MuiCheckbox-root": {
        padding: 0,
        margin: "1rem"
      },
      "& .MuiFormHelperText-root.Mui-error": {
        marginLeft: 0,
        fontFamily: "ScgFont, sans-serif",
        fontWeight: 400,
        fontSize: "1.1rem",
        lineHeight: "16px",
        color: theme.palette.scgPrimary.main
      },
      marginBottom: 20,
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "8px 11.6px",
          borderTop: `1px solid ${theme.palette.grey[300]}`,
          borderRight: `1px solid ${theme.palette.grey[300]}`
        }
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-root": {
          padding: "1.2rem 1.2rem ",
          borderRight: `1px solid ${theme.palette.grey[300]}`
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "none"
        }
      },
      "& .MuiTable-root": {
        overflowX: "auto",
        width: "100%",
        border: `1px solid ${theme.palette.info.dark}`,
        borderLeft: "none",
        "& .MuiTableBody-root > tr > td": {
          borderBottom: `1px solid ${theme.palette.grey[300]}`
        }
      }
    },
    boxCheckBox: {
      "& .MuiCheckbox-root": {
        marginTop: "0.5rem"
      },
      marginTop: "1rem",
      display: "flex",
      flexDirection: "column"
    },
    tableHeader: {
      height: "78px"
    },
    delete: {
      fontStyle: "italic",
      fontSize: "14px",
      lineHeight: "22px",
      fontFamily: "ScgFont, sans-serif",
      textAlign: "center",
      color: theme.palette.scgPrimary.main,
      fontWeight: 400
    },
    header: {
      display: "flex",
      margin: "1.8rem 0",
      alignItems: "center",
      color: theme.palette.grey[900]
    },
    txtInputSelect: {
      "&>div": {
        fontWeight: 400
      }
    },
    responsiveTable: {
      overflowX: "hidden"
    },
    scrollAble: {
      overflowX: "unset"
    },
    svgDatePicker: {
      marginRight: "0.8rem"
    },
    tableTabActive: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      background: theme.palette.info.dark,
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      borderBottom: 0
    },
    innerTabActive: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.info.main,
      position: "absolute",
      borderBottom: 0,
      color: "#FFFFFF"
    },
    tableTab: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      background: theme.palette.grey[400],
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      borderBottom: 0
    },
    innerTab: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.grey[300],
      color: theme.palette.grey[600],
      position: "absolute",
      borderBottom: 0
    },
    boxShadowTab: { filter: "drop-shadow(2px 0px 4px rgba(0, 0, 0, 0.25))" },
    tabB: {
      marginLeft: "-2rem"
    },
    z0: {
      zIndex: 0
    },
    z1: {
      zIndex: 1
    },
    z2: {
      zIndex: 2
    },
    z3: {
      zIndex: 3
    },
    zMax: {
      zIndex: 100
    },
    body3: {
      fontFamily: "SCG",
      fontSize: "1.4rem",
      fontWeight: 400,
      lineHeight: "22px",
      color: theme.palette.grey[900]
    },
    svg: {
      marginRight: "1.2rem"
    },
    cellCheckBox: {
      width: "64px",
      minWidth: "64px",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      paddingRight: "0px !important"
    },
    checkBox: {
      padding: "10px"
    },
    selectField: {
      "& .MuiSelect-root": {
        padding: "0.4rem 1.2rem"
        // color: theme.palette.grey[800]
      }
    },
    boxSearchInput: {
      "&>div": {
        width: "100%"
      },
      "& .MuiFormControl-root": {
        height: "35px",
        marginRight: "1rem"
      },
      "&>svg": {
        marginLeft: "0.5rem",
        cursor: "pointer"
      },
      display: "flex",
      alignItems: "center"
    },
    textFieldCustom: {
      "& .MuiOutlinedInput-input": {
        padding: "7px 16px"
      }
    },
    disabled: {
      pointerEvents: "none"
    },
    numberInput: {
      width: "120px"
    },
    noBorderRight: {
      borderRight: "0 !important"
    },
    borderLeft: {
      borderLeft: `1px solid ${theme.palette.grey[300]}`
    },
    borderLeftMain: {
      borderLeft: `1px solid ${theme.palette.info.dark}`
    },
    borderBottom: {
      borderBottom: `1px solid ${theme.palette.grey[300]} !important`
    },
    borderRight: {
      borderRight: `1px solid ${theme.palette.grey[300]} !important`
    },
    thDelivery: {
      background: "#E6F6F8 !important"
    },
    root: {
      marginTop: "4rem"
    },
    topBox: {
      position: "relative",
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "-3rem",
      height: "3.2rem"
    },
    fixedBtn: {
      position: "fixed",
      right: 0
    },
    txtError: {
      marginLeft: 0,
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400,
      fontSize: "1.1rem",
      lineHeight: "16px",
      color: theme.palette.scgPrimary.main,
      marginTop: "1rem"
    },
    ml10: {
      marginLeft: "1rem"
    },
    ml20: {
      minWidth: "64px",
      paddingLeft: "18px",
      textAlign: "center"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    boxQuantity: {
      display: "flex",
      alignItems: "center"
    },
    nonDeleteTxt: {
      color: theme.palette.grey[500]
    },
    deleteBox: {
      display: "flex"
    },
    textQuantityPopup: {
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 700,
      fontSize: "1.8rem",
      lineHeight: "24px"
    },
    customCell: {
      height: "12px",
      padding: "0.8rem 1.2rem !important"
    },
    unlimited: {
      paddingLeft: "0 !important"
    },
    delivery: {
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400,
      fontSize: "1.3rem",
      lineHeight: "20px",
      display: "flex",
      alignItems: "center",
      color: theme.palette.grey[900]
    },
    freezeCell: {
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 1
    },
    freezeCell1: {
      position: "sticky",
      left: 64,
      minWidth: 72,
      background: "inherit",
      zIndex: 1,
      "& svg": {
        width: 25
      },
      "&>div>div": {
        marginRight: "-1rem"
      }
    },
    buttonApply: {
      borderRadius: "4px",
      padding: "0.4rem 0.4rem",
      fontWeight: 400,
      fontSize: "1.2rem",
      lineHeight: "18px",
      background: "#009FB8",
      color: "white",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px",
      "&:hover, &:active": {
        color: "#009FB8",
        background: "#F2FAFB",
        outline: "1px solid #009FB8",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px"
      }
    },
    btnApplyOpen: {
      color: "#009FB8",
      background: "#F2FAFB",
      outline: "1px solid #009FB8",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px"
    },
    btnExternalLink: {
      boxSizing: "content-box",
      width: "20px",
      minWidth: "unset",
      height: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto",
      padding: ".6rem",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px",
      "& img": {
        width: "18px",
        height: "18px"
      }
    },
    freezeCell2: {
      position: "sticky",
      left: 136,
      minWidth: 360,
      background: "inherit",
      zIndex: 1
    },
    freezeCell2Details: {
      position: "sticky",
      left: 136,
      minWidth: 240,
      background: "inherit",
      zIndex: 1
    },
    freezeCell4: {
      position: "sticky",
      left: 650,
      zIndex: 1,
      background: `${theme.palette.background.default} !important`,
      borderTop: "0 !important"
    },
    quantityCell: {
      border: "0 !important",
      background: `${theme.palette.background.default} !important`,
      paddingLeft: "0 !important",
      paddingBottom: "0 !important"
    },
    boxSvg: {
      cursor: "pointer",
      maxWidth: "4rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:active": {
        background: "#EEEEEE",
        borderRadius: "4px",
        "& svg path": {
          stroke: theme.palette.grey[700]
        }
      },
      "&:hover": {
        "& svg path": {
          stroke: theme.palette.grey[700]
        }
      }
    },
    boxPlant: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "& >span": {
        marginBottom: "0.8rem"
      }
    },
    noBorderLeft: {
      borderLeft: "0 !important"
    },
    cellDelivery: {
      padding: "0 1.2rem !important",
      maxHeight: "40px",
      height: "40px"
    },
    cellDelivery2: {
      padding: "0 !important",
      maxHeight: "40px",
      height: "40px"
    },
    cellUnlimited: {
      background: "#F2FAFB !important"
    },
    cellSize13: {
      fontSize: "1.3rem"
    },
    qtyHeaderTxt: {
      minWidth: 115,
      textAlign: "right"
    },
    colA1: {
      minWidth: 120
    },
    colA2: {
      minWidth: 64
    },
    colA3: {
      minWidth: 64,
      textWrap: "nowrap"
    },
    colA4: {
      minWidth: 64
    },
    colA5: {
      minWidth: 112
    },
    colA6: {
      minWidth: 104
    },
    colA7: {
      minWidth: 128
    },
    colA8: {
      minWidth: 88
    },
    colA9: {
      minWidth: 120
    },
    colA10: {
      minWidth: 198
    },
    colA11: {
      minWidth: 56
    },
    colA19: {
      minWidth: 130
    },
    colA20: {
      minWidth: 120
    },
    colA21: {
      minWidth: 142
    },
    colC1: {
      minWidth: 312
    },
    colC2: {
      minWidth: 248
    },
    colC3: {
      minWidth: 248
    },
    colC4: {
      minWidth: 420
    },
    colC5: {
      minWidth: 420
    },
    flex5: {
      whiteSpace: "pre-line",
      flex: 5
    },
    flex1: {
      flex: 1
    },
    btnThin: {
      height: 32
    },
    flex: {
      display: "flex",
      flexWrap: "wrap"
    },
    tabBox: { display: "flex" },
    textField: {
      maxWidth: 600,
      resize: "both",
      height: "100%",
      "& > *, & textarea": {
        height: "98% !important"
      }
    }
  }),
  {
    name: "ItemDetailCS"
  }
);

export default useStyles;
